/* eslint-disable no-unused-vars */
import { Switch } from 'antd';
import React, { useState } from 'react';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import DokanTimePicker from './DokanTimePicker';

const DokanSwitchButton = ({ label = 'Switch Button', defaultChecked = false, dokanStoreTime }) => {
    const [isOn, setIsOn] = useState(defaultChecked);
    const handleChange = () => {
        setIsOn(!isOn);
    };
    // console.log(window.location.origin);
    return (
        <div>
            <div className="flex justify-between items-center mt-20px">
                <div className="w-1/12">
                    <p className="text-base font-light ">{label}</p>
                </div>
                <div className="flex items-center justify-center w-1/12">
                    <Switch
                        checkedChildren={<CheckOutlined />}
                        unCheckedChildren={<CloseOutlined />}
                        defaultChecked={defaultChecked}
                        onChange={handleChange}
                        className="ml-30px"
                    />
                </div>
                <div className="w-8/12">
                    {isOn && (
                        <>
                            <div className="flex justify-start items-center">
                                <div>
                                    <DokanTimePicker _time={dokanStoreTime?.opening_time} />
                                </div>
                                <div>
                                    <DokanTimePicker _time={dokanStoreTime?.closing_time} />
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DokanSwitchButton;
